export const APP_TIME_ZONE = process.env.REACT_APP_TIME_ZONE || 'Australia/Melbourne';

const appClock = new Intl.DateTimeFormat('en-AU', {
  timeZone: APP_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23'
});

const appParts = (date = new Date()) =>
  appClock.formatToParts(date).reduce((parts, part) => {
    parts[part.type] = part.value;
    return parts;
  }, {});

const normalizeTime = (time) => {
  const [hour = '0', minute = '0'] = String(time || '').split(':');
  return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
};

export const getAppDate = (date = new Date()) => {
  const parts = appParts(date);
  return `${parts.year}-${parts.month}-${parts.day}`;
};

export const getAppDateTime = (date = new Date()) => {
  const parts = appParts(date);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
};

export const formatAppDateTime = (date) => {
  const parts = appParts(date);
  return `${parts.day} ${parts.month} ${parts.year} at ${parts.hour}:${parts.minute}`;
};

export const journeyDateTimeValue = (date, time) => `${date}T${normalizeTime(time)}`;

export const isJourneyUpcoming = (date, time, now = new Date()) =>
  journeyDateTimeValue(date, time) > getAppDateTime(now);

export const isJourneyOverdue = (date, time, now = new Date()) =>
  journeyDateTimeValue(date, time) <= getAppDateTime(now);

export const isJourneyMoreThanTwoMinutesPast = (date, time, now = new Date()) =>
  journeyDateTimeValue(date, time) < getAppDateTime(new Date(now.getTime() - 2 * 60 * 1000));
